import { BehaviorLog } from '@/common/model/recommend/behavior'

export const BehaviorLogApiPath = {
  LIST_BEHAVIOR_LOGS: '/api/sites/{site_id}/behavior-logs' // GET List Behavior Logs
}

export type BehaviorLogApiPath = (typeof BehaviorLogApiPath)[keyof typeof BehaviorLogApiPath]

export interface ListBehaviorLogsVars {
  site_id: number
  page?: number
  per_page?: number
  search?: string | null
  action_type?: string | null
  s_visitor_id?: string | null
  s_item_id?: string | null
  s_category_id?: string | null
  s_customer_id?: string | null
  s_date_from?: string | null
  s_date_to?: string | null
}

export interface ListBehaviorLogsResponse {
  logs: BehaviorLog[]
  total: number
}
